import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import { useHistory } from "react-router-dom";
import FeelingProud from "./FeelingProud";
import { style } from "glamor";

export default function Greeting(props) {
  const theme = props.theme;
  const history = useHistory();

  const contactBtnStyles = style({
    backgroundColor: `${theme.accentBright}`,
    ":hover": {
      boxShadow: `0 5px 15px ${theme.accentBright}`,
    },
  });

  const resumeBtnStyles = style({
    backgroundColor: `#e44160`,
    ":hover": {
      boxShadow: `0 5px 15px #e44160`,
    },
  });

  // Add waving hand emoji by splitting the title text
  const titleParts = greeting.title.split("👋");
  const titleWithWavingEmoji =
    titleParts.length > 1 ? (
      <>
        {titleParts[0]}
        <span className="wave-emoji">👋</span>
        {titleParts.slice(1).join("👋")}
      </>
    ) : (
      greeting.title
    );

  // Add animated fire emoji
  const subtitleParts = greeting.subTitle.split("🔥");
  const subtitleWithFireEmoji =
    subtitleParts.length > 1 ? (
      <>
        {subtitleParts[0]}
        <span className="fire-emoji">🔥</span>
        {subtitleParts.slice(1).join("🔥")}
      </>
    ) : (
      greeting.subTitle
    );

  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text">{titleWithWavingEmoji}</h1>
              <p
                className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText }}
              >
                <span>I'm </span>
                <span style={{ color: theme.accentColor }}>
                  {greeting.full_name},{" "}
                </span>
                {subtitleWithFireEmoji}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <button
                  {...contactBtnStyles}
                  className="button"
                  onClick={() => {
                    history.push("/contact");
                  }}
                >
                  Contact Me
                </button>
                <a
                  href={greeting.resumeLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <button {...resumeBtnStyles} className="button resume-btn">
                    View Resume
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <FeelingProud theme={theme} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
